import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import LandingPage from "./landingPage/LandingPage";
import HowItWorks from "./landingPage/HowItWorks";
import AppProvider from "./AppProvider";
import Page from "./landingPage/Page";

import pageContents from "../pages";

const Router = () => (
    <BrowserRouter>
        <AppProvider>
            <Switch>
                <Route exact path="/" component={() => <LandingPage />} />
                <Route exact path="/how" component={() => <HowItWorks />} />
                {pageContents.map((item, index) => {
                    const { url, title, subtitle, content } = item;

                    return (
                        <Route
                            key={`page--${index}`}
                            exact
                            path={url}
                            component={() => (
                                <Page
                                    title={title}
                                    subtitle={subtitle}
                                    content={content}
                                />
                            )}
                        />
                    );
                })}
            </Switch>
        </AppProvider>
    </BrowserRouter>
);

export default Router;



// WEBPACK FOOTER //
// ./src/components/Router.jsx